(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/services/assets/hooks/use-active-competition.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/services/assets/hooks/use-active-competition.js');
"use strict";

const _svs$components$marke = svs.components.marketplaceCompetition.services.hooks,
  useCompetition = _svs$components$marke.useCompetition,
  useActiveCompetitionId = _svs$components$marke.useActiveCompetitionId;
const useActiveCompetition = () => useCompetition(useActiveCompetitionId());
setGlobal('svs.components.marketplaceCompetition.services.hooks.useActiveCompetition', useActiveCompetition);

 })(window);